import React, { useState, useEffect } from "react";

import { LoyaltyTwoTone } from "@material-ui/icons";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { format } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import axios from "axios";
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import {
	MuiPickersUtilsProvider,
	KeyboardTimePicker,
	KeyboardDatePicker
} from "@material-ui/pickers";
import { NavLink } from "react-router-dom";
import {get_cookies, isLoggedIn, timeZoneChanger} from "../../../components/Cookies/Cookies";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import LoadingModal from "../../../components/Modal/LoadingModal";
import MessageBox from "../../../components/MessageBox/MessageBox";
import {  useParams, useHistory } from "react-router-dom";
import Preloader from "../../../components/Preloader/Preloader";
import LoadingOverlay from 'react-loading-overlay';
import SalesModal from "../SalesModal";
import { Breadcrumbs, Typography } from "@material-ui/core";

const useStyles = makeStyles({
	title: {
		marginTop: 0
	},
	field: {
		width: "100%",
		marginBottom: "1rem"
	},
	autoComplete: {
		width: "100%",
		marginTop: "0",
		marginBottom: "0.5rem"
	},
	date: {
		width: "100%",
		marginBottom: "1rem"
	},
	buttonContainer: {
		textAlign: "right"
	}
});

const SalesOrder = () => {
	const classes = useStyles();
	const x = 0;
	useEffect(() => {
		//
		timeZoneChanger(setSelectedDate);
		isLoggedIn();
	}, [x]);

	useEffect(() => {
		//
		getShippingList();
		getWarehouseList();
	}, []);

	const defaultProps = {
		options: selectType,
		getOptionLabel: option => option.title
	};
	const [selectedDate, setSelectedDate] = React.useState(null);
	const [shipping, setShipping] = useState(null);
	const [warehouse, setWarehouse] = useState(null);
	const [branchIdNo, setBranchIdNo] = useState(get_cookies("branchidno"));
	//state for disabling/enabling button
	const [btnDisabled, setBtnDisabled] = useState(true);

	const [trantype, setTrantype] = useState("");
	const [shippingId, setShippingId] = useState(0);
	const [warehouseId, setWarehouseId] = useState(0);
	const [idNo, setIdNo] = useState("");

    const [showMsgBox, setShowMsgBox] = useState(false);
    const [msgBoxContent, setMsg] = useState("Empty");
    const [msgType, setMsgType] = useState("success");
	const [showOverlay, setShowOverlay] = useState(false);
    const [overLayMsg, setOverlayMsg] = useState(false);

	const [openModal, setOpenModal] = useState(false);
	
	let history = useHistory();

	const [defaultWarehouse, setDefaultWarehouse] = useState(null);

	const getShippingList = async () => {
		await axios
			.get(process.env.REACT_APP_API_URL + "/get_shipping_list", {
				params: {
					jc_user_id_no: branchIdNo //branchIdNo
				}
			})
			.then(res => {
				setShipping(res.data.data);
			})
			.catch(error => {
				// console.log(error.message);
			});
	};
	const getWarehouseList = async () => {
		await axios.get(process.env.REACT_APP_API_URL+'/get_warehouse_list', {
			params:{
				jc_user_id_no: branchIdNo,  //branchIdNo
			}
		}).then((res)=>{
			setWarehouse(res.data.data);
			res.data.data.some(function(entry, i) {
				if (entry.description == "HQ Warehouse") {
					//console.log(i);
					//console.log(entry.id);
					setDefaultWarehouse(i);
					setWarehouseId(entry.id);
					return true;
				}
			});

		}).catch((error)=>{
			// console.log(error.message);
		});
	}
	const validate_idno = async () => {
		setOpenModal(true);

		setBtnDisabled(true);
		await axios.get(process.env.REACT_APP_API_URL+'/sales_order_form', {
			params:{
				jc_u_idno: branchIdNo,  //branchIdNo
				trandate:selectedDate, 
				shipping: shippingId, 
				warehouse: warehouseId, 
				idno: idNo, 
				trantype: trantype, 
				curcode: get_cookies('curcode'), 
			}
		}).then((res)=>{
		setOpenModal(false);

			history.push("/sales/sales-order-information/"+shippingId+"/"+warehouseId+"/"+idNo+"/"+trantype+"/"+format(new Date(selectedDate), "yyyy-MM-dd"));
		}).catch((error)=>{
			setOpenModal(false);

			// console.log(error.message);
			setShowMsgBox(true);
			setMsg("ID No not found");
			setMsgType("warning");
			setTimeout(() => {
				setShowMsgBox(false);
				setBtnDisabled(false); // re-enable
			}, 2500)
		});
	}

	const selectShippingProps = {
		options: shipping,
		getOptionLabel: option => option.description
	};

	const selectLocationProps = {
		options: warehouse,
		getOptionLabel: option => option.description
	};

	const handleDateChange = date => {
		setSelectedDate(date);
	};

	const modalMessage= 'Validating ID Number...';

	useEffect(() => {
		timeZoneChanger(setSelectedDate);
		if (idNo && trantype && shippingId && warehouseId) {
			setBtnDisabled(false); // re-enable
		} else {
			setBtnDisabled(true); // re-enable
		}
	}, [idNo, trantype, shippingId, warehouseId]);

	const ColorButton = withStyles(() => ({
    		root: {
    		  color: "#fff",
    		  backgroundColor: "#4caf50",
    		  '&:hover': {
    		    backgroundColor: "#fff",
    		    color: "#4caf50",
    		  }
    		},
  			}))(Button);


	return (
		<div className="page">
			{/* <LoadingOverlay
			    active={showOverlay}
				spinner
				text={overLayMsg}
				> */}
			<div className="page-header">
				<div className="page-icon">
					<ShoppingCartIcon />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/sales">
						<h2 className="header-title">Sales</h2>
					</NavLink>
					<Typography color="textPrimary">Sales Order</Typography>
				</Breadcrumbs>
			</div>
			{shipping&&warehouse&&(defaultWarehouse != null) ? (<div className="page-container">
				<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
				<SalesModal open={openModal} overLayMsg={modalMessage}/>
				<Grid container spacing={3}>
					<Grid item xs="12" sm="6">
						<Card>
							<CardContent>
								<h4 className={classes.title}>Deliver to</h4>
								<form noValidate autoComplete="off">
									<TextField
										id="outlined-basic"
										label="Enter Id No."
										variant="outlined"
										type="text"
										className={classes.field}
										value={idNo} //to avoid label overlapping bug
										onChange={e => {
											setIdNo(e.target.value);
										}}
									/>
									<Autocomplete
										{...defaultProps}
										id="auto-complete"
										autoComplete
										includeInputInList
										className={classes.autoComplete}
										renderInput={params => (
											<TextField
												{...params}
												label="Select Transaction Type"
												margin="normal"
												variant="outlined"
											/>
										)}
										onChange={(event, newValue) => {
											if (
												!newValue == "" ||
												!newValue == null
											) {
												setTrantype(newValue.title);
											}else{
												setTrantype(null);
											}
										}}
									/>
								</form>
							</CardContent>
						</Card>
					</Grid>
					<Grid item xs="12" sm="6">
						<Card>
							<CardContent>
								<h4 className={classes.title}>Deliver from</h4>
								<form noValidate autoComplete="off">
									<MuiPickersUtilsProvider
										utils={DateFnsUtils}
									>
										<KeyboardDatePicker
											disableToolbar
											variant="inline"
											format="MMM dd, yyyy"
											id="date-picker-inline"
											label="Date picker inline"
											value={selectedDate}
											onChange={handleDateChange}
											inputVariant="outlined"
											margin="normal"
											className={classes.date}
											KeyboardButtonProps={{
												"aria-label": "change date"
											}}
											InputProps={{
												readOnly: true,
											  }}
										/>
									</MuiPickersUtilsProvider>
									<Autocomplete
										{...selectShippingProps}
										id="auto-complete-1"
										autoComplete
										includeInputInList
										renderInput={params => (
											<TextField
												{...params}
												label="Select Shipping"
												variant="outlined"
											/>
										)}
										onChange={(event, newValue) => {
											if (
												!newValue == "" ||
												!newValue == null
											) {
												//console.log(newValue.description);
												setShippingId(newValue.id);
											}else{
												setShippingId(null);
											}
										}}
									/>
									<Autocomplete
										{...selectLocationProps}
										id="auto-complete-2"
										defaultValue={warehouse[defaultWarehouse]}
										autoComplete
										includeInputInList
										renderInput={params => (
											<TextField
												{...params}
												margin="normal"
												label="Select Location"
												variant="outlined"
											/>
										)}
										onChange={(event, newValue) => {
											if (
												!newValue == "" ||
												!newValue == null
											) {
												//console.log(newValue.description);
												setWarehouseId(newValue.id);
											}else{
												setWarehouseId(null);
											}
										}}
									/>
								</form>
							</CardContent>
						</Card>
					</Grid>
					<Grid item xs="12" className={classes.buttonContainer}>
							<ColorButton disabled={btnDisabled} onClick={()=>{validate_idno()}} variant="contained" color="primary" classes={{
    						root: classes.root, 
        					disabled: classes.disabled}}>
								Next
							</ColorButton>
					</Grid>
				</Grid>
		</div>
		) : (<Preloader />)}
			{/* </LoadingOverlay> */}
		</div>
	);
};

const selectType = [
	{ title: "Regular" },
	{ title: "Credit Card Promo" },
	{ title: "MMP Purchase" },
	{ title: "PPV Voucher" },
	{ title: "BCO Purchase" },
	{ title: "MC Purchase" },
	{ title: "MS Purchase" },
	{ title: "Center Initial Purchase" },
	{ title: "Center Package" },
	{ title: "Subsidy DP" },
	{ title: "Representation Daily PSO" },
	{ title: "Representation Daily Events" },
	{ title: "Representation Daily Management" },
	{ title: "Representation Piso Package" },
	{ title: "Representation Promo" },
	{ title: "Representation BC Package" },
	{ title: "Representation FC Package" },
	{ title: "Representation Account Upgrade" },
	{ title: "Representation Product Training" },
	{ title: "Representation Pantry" },
	{ title: "Representation QA" },
	{ title: "Representation Additional Products Promo" },
	{ title: "Representation Others"},
	{ title: "Representation Management"}
];

export default SalesOrder;
